import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowRightLong(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M17 12H3" }),
            React.createElement("path", { fill: "currentColor", d: "m21.715 11.797-5.45-3.893a.8.8 0 0 0-1.265.65v6.891a.8.8 0 0 0 1.265.651l5.45-3.893a.25.25 0 0 0 0-.406" })));
}
const ArrowRightLong = forwardRef(_ArrowRightLong);
export { ArrowRightLong };
